class AnnouncementBarSlider extends HTMLElement {
  constructor() {
    super();

    this.track = this.querySelector('[data-abs-track]');
    this.slides = Array.from(this.querySelectorAll('[data-abs-slide]'));
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    // スライドが1枚以下なら何もしない
    if (!this.track || this.slides.length <= 1) return;

    this.realCount = this.slides.length;
    this.currentIndex = 1; // 先頭クローンの次（本物の最初のスライド）
    this.isTransitioning = false;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.setupClones();
    this.setPosition(false);

    if (this.prevButton) this.prevButton.addEventListener('click', () => this.move(-1));
    if (this.nextButton) this.nextButton.addEventListener('click', () => this.move(1));
    this.track.addEventListener('transitionend', this.onTransitionEnd.bind(this));

    if (this.dataset.autoplay === 'true') {
      this.autoplaySpeed = (parseFloat(this.dataset.speed) || 5) * 1000;
      this.startAutoplay();
      // ホバー・フォーカス中は自動再生を一時停止
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
      this.addEventListener('focusin', () => this.stopAutoplay());
      this.addEventListener('focusout', () => this.startAutoplay());
    }
  }

  // 先頭に「最後のスライド」、末尾に「最初のスライド」の複製を追加してループを成立させる
  setupClones() {
    const firstClone = this.slides[0].cloneNode(true);
    const lastClone = this.slides[this.slides.length - 1].cloneNode(true);

    [firstClone, lastClone].forEach(clone => {
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('id');
      clone.querySelectorAll('a, button').forEach(el => el.setAttribute('tabindex', '-1'));
    });

    this.track.insertBefore(lastClone, this.slides[0]);
    this.track.appendChild(firstClone);
  }

  setPosition(animate) {
    this.track.style.transition = animate && !this.reducedMotion ? '' : 'none';
    this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
    if (!animate) {
      // transition を確実に無効化した状態で位置を確定させる
      void this.track.offsetWidth;
    }
  }

  move(direction) {
    if (this.isTransitioning) return;
    this.isTransitioning = true;
    this.currentIndex += direction;

    this.track.style.transition = this.reducedMotion ? 'none' : '';
    this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;

    // transition なしの場合は transitionend が発火しないため手動で処理
    if (this.reducedMotion) this.onTransitionEnd({ propertyName: 'transform' });
  }

  onTransitionEnd(event) {
    if (event && event.propertyName && event.propertyName !== 'transform') return;
    this.isTransitioning = false;

    if (this.currentIndex === this.realCount + 1) {
      // 末尾クローン（=最初のスライドの複製）→ 本物の最初へ瞬間移動
      this.currentIndex = 1;
      this.snapWithoutAnimation();
    } else if (this.currentIndex === 0) {
      // 先頭クローン（=最後のスライドの複製）→ 本物の最後へ瞬間移動
      this.currentIndex = this.realCount;
      this.snapWithoutAnimation();
    }
  }

  snapWithoutAnimation() {
    this.track.style.transition = 'none';
    this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
    void this.track.offsetWidth; // reflow を強制してジャンプを確定
  }

  startAutoplay() {
    if (this.dataset.autoplay !== 'true') return;
    this.stopAutoplay();
    this.autoplayTimer = setInterval(() => this.move(1), this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.autoplayTimer) clearInterval(this.autoplayTimer);
  }
}

customElements.define('announcement-bar-slider', AnnouncementBarSlider);
